const getters = {
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  token: state => state.user.token,
  info: state => state.user.info,
  permission: state => state.user.permission,
}
export default getters
